import { render, staticRenderFns } from "./TheSecurityPolicyLayout.vue?vue&type=template&id=64794fc2&scoped=true"
var script = {}
import style0 from "./TheSecurityPolicyLayout.vue?vue&type=style&index=0&id=64794fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64794fc2",
  null
  
)

export default component.exports